/**
 * Ciclo de vida do card: monta um root Vue próprio no body e o remove por
 * completo depois.
 *
 * POR QUE UM ROOT PRÓPRIO
 * O card não é modal e não é disparado por GlobalBus, então não cabe no
 * `global-modals.vue`; e montá-lo no `main.vue` exigiria tocar no shell, que é
 * exatamente o que este módulo se propôs a não fazer.
 *
 * A ARMADILHA QUE ISSO ESCONDE
 * `$mount(host)` SUBSTITUI o elemento host pelo que foi renderizado — depois
 * disso o host não está mais no DOM, e guardar a referência dele não serve de
 * nada. E `$destroy()` desmonta a instância mas NÃO remove o `$el`. Sem tirar
 * o `$el` na mão, fechar no "x" deixaria um card morto grudado no canto até o
 * próximo reload, e o guard de "já existe um card" seria liberado — abrindo
 * espaço para um segundo card empilhado por cima do cadáver do primeiro.
 */
let instancia = null

export function cardEstaMontado() {
  return !!instancia
}

/**
 * @param {Object} Vue construtor Vue (injetado — `registerModule` já o entrega)
 * @param {Object} opcoes `{ store, router, componente, props, aoFechar }`
 */
export function montarCard(Vue, opcoes) {
  if (instancia) return instancia

  const host = document.createElement('div')
  document.body.appendChild(host)

  instancia = new Vue({
    store: opcoes.store,
    router: opcoes.router,
    render(h) {
      return h(opcoes.componente, {
        props: opcoes.props,
        on: { fechar: opcoes.aoFechar },
      })
    },
  }).$mount(host)

  return instancia
}

export function destruirCard() {
  if (!instancia) return

  const elemento = instancia.$el
  instancia.$destroy()
  if (elemento && elemento.remove) {
    elemento.remove()
  }
  instancia = null
}
